import cache from '@/plugins/cache';
import auth from '@/plugins/auth';
import modal from '@/plugins/modal';

export default {
  install(Vue) {
    // 缓存对象
    Vue.config.globalProperties.$cache = cache
    // 认证对象
    Vue.config.globalProperties.$auth = auth
    // 模态框对象
    Vue.config.globalProperties.$modal = modal
  }
}
